// extracted by mini-css-extract-plugin
module.exports = {"otherTags":"ob_wP1roc","otherTags__tagItem":"ob_GitI8s"};